const burritos = [
    {name: "California Burrito", price: {chicken: 10.99, Steak: 12.99}, desc: "Large flour tortilla filled with steak or frilled chicken, rice, beans, sour cream, tomatoes, lettuce, and covered with cheese dip."},
    {name: "Burrito Real", price: {chicken: 8.99, Steak: 9.99}, desc: "A large flour tortilla filled with seasoned ground beef or chicken topped with lettuce, tomato, sour cream, shredded cheese, and salsa. Served with rice and beans."},
    {name: "Burrito Tapatio", price: 10.99, desc: "Two flour tortillas filled with steak, grilled chicken, and chorizo. Served with rice."}
];

export {burritos};